module.exports = __webpack_public_path__ + "static/media/previewDocumentsData.ead69b5f.png";